import { getFunctions, httpsCallable } from '../../firebase';
import { createLogger } from '../../utils/logger';

const logger = createLogger('verifyWipayPayment');

/**
 * Ask the verifyWipayPayment Cloud Function to check WiPay callback hash,
 * optional WAPI transaction lookup, and Firestore alignment for an order.
 * @param {string} orderId
 * @returns {Promise<Record<string, unknown>>}
 */
export async function verifyWipayPayment(orderId) {
  if (!orderId || typeof orderId !== 'string') {
    throw new Error('Order ID is required.');
  }

  try {
    const callable = httpsCallable(getFunctions(), 'verifyWipayPayment');
    const result = await callable({ orderId: orderId.trim() });
    return result?.data || {};
  } catch (error) {
    logger.error('[verifyWipayPayment] Cloud Function call failed:', error);
    throw error;
  }
}
